import { scrollToSubject } from './scrollToSubject';

type FocusableElement = HTMLInputElement | HTMLTextAreaElement | null;

export function focusAnswer(subjectId: number) {
  const subject = document.querySelector(
    `[data-subject-answer="${subjectId}"]`
  ) as FocusableElement;

  if (subject && subject.focus) {
    subject.focus();
  }

  scrollToSubject(subjectId);
}
